// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workContractModification {
  background-color: #f3f4f6;
}
.workContractModification .container {
  margin: auto;
  width: 90%;
}
.workContractModification .container .titleBar {
  width: 90%;
  margin: auto;
  padding-top: 60px;
}
.workContractModification .container .titleBar .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.workContractModification .container .titleBar .subHeader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.workContractModification .container .breadCrumb {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.workContractModification .container .breadCrumb .mainScreen,
.workContractModification .container .breadCrumb .secondScreen {
  display: inline-block;
  margin-right: 10px;
}
.workContractModification .container .breadCrumb .secondScreen {
  margin-left: 10px;
}
.workContractModification .container .nameContainer {
  display: flex;
  flex-direction: row;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  margin-top: 10px;
}
.workContractModification .container .nameContainer .image {
  background: #c1c1c1;
  border: 1px solid #c1c1c1;
  color: white;
  height: 60px;
  width: 60px;
  border-radius: 30px;
  padding-top: 4px;
  padding-left: 6px;
  text-align: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
}
.workContractModification .container .nameContainer .nameText {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  position: relative;
  top: 10px;
  left: 10px;
}
.workContractModification .container .card {
  background-color: white;
  margin-top: 32px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  height: 706px;
}
.workContractModification .container .card .leftContainer {
  width: 70%;
  height: 100%;
  display: inline-block;
  padding-left: 32px;
  padding-right: 32px;
  border-right: 1px solid #f2f2f2;
}
.workContractModification .container .card .leftContainer .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
  position: relative;
  top: 32px;
  padding-bottom: 32px;
}
.workContractModification .container .card .leftContainer .checkboxRow {
  margin-top: 18px;
  margin-bottom: 40px;
}
.workContractModification .container .card .leftContainer .checkboxRow .checkBoxWrapper {
  display: inline-block;
  margin-right: 30px;
}
.workContractModification .container .card .rightContainer {
  width: 30%;
  position: relative;
  bottom: 376px;
  display: inline-block;
  padding-left: 32px;
  padding-right: 32px;
}
.workContractModification .container .card .rightContainer .titleText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.workContractModification .container .card .rightContainer .second {
  margin-top: 70px;
}
.workContractModification .container .card .rightContainer .description {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/screens/workContractModification/workContractModification.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AACI;EAwBI,YAAA;EACA,UAAA;AAtBR;AAFQ;EACI,UAAA;EACA,YAAA;EACA,iBAAA;AAIZ;AAFY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIhB;AAFY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIhB;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAGY;;EAEI,qBAAA;EACA,kBAAA;AADhB;AAGY;EACI,iBAAA;AADhB;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AAHZ;AAKY;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAHhB;AAMY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAJhB;AAQQ;EACI,uBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;AANZ;AAOY;EACI,UAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;AALhB;AAMgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;AAJpB;AAOgB;EACI,gBAAA;EACA,mBAAA;AALpB;AAMoB;EACI,qBAAA;EACA,kBAAA;AAJxB;AASY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAPhB;AASgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPpB;AAUgB;EACI,gBAAA;AARpB;AAWgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATpB","sourcesContent":[".workContractModification {\n    background-color: #f3f4f6;\n\n    .container {\n        .titleBar {\n            width: 90%;\n            margin: auto;\n            padding-top: 60px;\n\n            .header {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n            }\n            .subHeader {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n            }\n        }\n\n        margin: auto;\n        width: 90%;\n\n        .breadCrumb {\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n\n            .mainScreen,\n            .secondScreen {\n                display: inline-block;\n                margin-right: 10px;\n            }\n            .secondScreen {\n                margin-left: 10px;\n            }\n        }\n\n        .nameContainer {\n            display: flex;\n            flex-direction: row;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            margin-top: 10px;\n\n            .image {\n                background: #c1c1c1;\n                border: 1px solid #c1c1c1;\n                color: white;\n                height: 60px;\n                width: 60px;\n                border-radius: 30px;\n                padding-top: 4px;\n                padding-left: 6px;\n                text-align: center;\n                font-weight: 500;\n                font-size: 24px;\n                line-height: 34px;\n                display: flex;\n                align-items: center;\n            }\n\n            .nameText {\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n                position: relative;\n                top: 10px;\n                left: 10px;\n            }\n        }\n\n        .card {\n            background-color: white;\n            margin-top: 32px;\n            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n            border-radius: 8px;\n            height: 706px;\n            .leftContainer {\n                width: 70%;\n                height: 100%;\n                display: inline-block;\n                padding-left: 32px;\n                padding-right: 32px;\n                border-right: 1px solid #f2f2f2;\n                .header {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 30px;\n                    color: #333333;\n                    position: relative;\n                    top: 32px;\n                    padding-bottom: 32px;\n                }\n\n                .checkboxRow {\n                    margin-top: 18px;\n                    margin-bottom: 40px;\n                    .checkBoxWrapper {\n                        display: inline-block;\n                        margin-right: 30px;\n                    }\n                }\n            }\n\n            .rightContainer {\n                width: 30%;\n                position: relative;\n                bottom: 376px;\n                display: inline-block;\n                padding-left: 32px;\n                padding-right: 32px;\n\n                .titleText {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n\n                .second {\n                    margin-top: 70px;\n                }\n\n                .description {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: #999999;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
